import fnsCs from 'date-fns/locale/cs';
import fnsEn from 'date-fns/locale/en-US';
import fnsPl from 'date-fns/locale/pl';
import fnsSk from 'date-fns/locale/sk';

const locales = {
  en: fnsEn,
  cs: fnsCs,
  pl: fnsPl,
  sk: fnsSk,
};

const getFnsLocale = language => ({ locale: locales[language] });

export default getFnsLocale;
